import { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import {
  XMarkIcon,
  ChevronRightIcon,
  ChatBubbleLeftEllipsisIcon,
  ArrowRightStartOnRectangleIcon,
  GiftIcon,
} from "@heroicons/react/24/outline";
import { LevelData, LevelProgressbar, Title } from "../backgrounds/LevelUser";
import { capitalizeFirstLetter } from "../../utils/capitalize";
import { closeSession } from "../../utils/closeSession";
import { DisclosureInviteFriends } from "./disclosure/Friends/InviteFriends";
import { DisclosureLastActivity } from "./disclosure/LastActivity";
import { Notifications } from "../notifications/Notifications";
import { NotificationsContext } from "../../context/Disclosures/notifications/notificationsContext";
import { RewardsViewContext } from "../../context/Disclosures/rewards/rewardsContext";
import { IndexedDBService } from "../../services/indexedDbService";
/* import { useChat } from "../../context/ChatIaContext/ChatIaContext"; */

const avatarImgDefault = "https://galilea-avatares.s3.amazonaws.com/avatar-undefined.png";
const indexedDbService = new IndexedDBService();

export function CharacterNavbar(props) {
  /* const { toggleChat } = useChat(); */
  const { notificationsData } = useContext(NotificationsContext);
  const { updateRewardsView } = useContext(RewardsViewContext);
  const [pendingsRewards, setPendingsRewards] = useState(0);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleCloseSession = () => {
    closeSession();
    navigate("/ingresar");
  }

  const navigation = [
    {
      disclosure: <DisclosureInviteFriends />,
      id: "IA"
    },
    {
      name: "Hablar con un asesor",
      href: "https://api.whatsapp.com/send/?phone=+573124008320&text=Hola, necesito un asesor",
      icon: <ChatBubbleLeftEllipsisIcon />,
      id: "WA",
      /* onClick: () => handleOpenChatBot() */
    },
    {
      disclosure: <Notifications />,
      id: "NO"
    },
    {
      disclosure: < DisclosureLastActivity />,
      id: "MV"
    },
    {
      name: "Recompensas",
      icon: <GiftIcon />,
      id: "RE",
      onClick: () => handleOpenDisclosure(),
    },
  ];

  /* const handleOpenChatBot = () => {
    setOpen(false);
    toggleChat();
  } */

  const handleOpenDisclosure = () => {
    updateRewardsView({
      openDisclosure: true,
      openDisclosureMyRewards: true
    });
  };

  const handleFindPendingsRewards = async () => {
    try {
      let idRewards = 'rewards';
      let item = await indexedDbService.findItem('id', idRewards);
      if (item) {
        setPendingsRewards(item.rewardsPending);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    handleFindPendingsRewards();
  }, []);

  return (
    <>
      <div className="cursor-pointer" onClick={() => setOpen(true)} href="#">
        <div className="relative">
          <img
            className="h-12 w-auto rounded-full cursor-pointer"
            src={localStorage.getItem('avatar') ?? avatarImgDefault}
            alt="Galilea"
          />
          {
            notificationsData.unreadNotifications === true &&
            <div className="absolute w-3 h-3 bg-red rounded-full right-0 top-0 border-2 border-purpleLight"></div>
          }

        </div>
      </div>
      <Dialog open={open} onClose={setOpen} className="relative z-40">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-darkBgLight bg-opacity-75 transition-opacity duration-500 ease-in-out data-[closed]:opacity-0"
        />

        <div className="fixed inset-x-0 overflow-hidden">
          <div className="absolute inset-0 overflow-hidden">
            <div className="pointer-events-none fixed inset-y-0 md:right-0 flex max-w-full pr-10 md:pr-0 md:pl-10">
              <DialogPanel
                transition
                className="pointer-events-auto w-screen max-w-sm transform transition duration-500 ease-in-out data-[closed]:-translate-x-full md:data-[closed]:translate-x-full sm:duration-700"
              >
                <div className="flex h-full flex-col bg-white py-6 shadow-xl rounded-r-2xl md:rounded-r-none md:rounded-l-2xl tracking-tight font-walsheim px-4 sm:px-6">
                  <div className="">
                    <div className="flex items-start justify-between">
                      <DialogTitle>
                        <img
                          className="h-16 w-auto rounded-full cursor-pointer"
                          src={localStorage.getItem('avatar') ?? avatarImgDefault}
                          alt="Galilea"
                        />

                        {/*  {
                          notificationsData.unreadNotifications === true &&
                          <div className="absolute w-3 h-3 bg-red rounded-full left-18 top-7 border-2 border-purpleLight"></div>
                        } */}

                      </DialogTitle>
                      <div className="ml-3 flex h-7 items-center">
                        <button
                          type="button"
                          onClick={() => setOpen(false)}
                          className="relative bg-white text-grayP focus:outline-none"
                        >
                          <span className="absolute" />
                          <span className="sr-only">Close panel</span>
                          <XMarkIcon aria-hidden="true" className="h-6 w-6" />
                        </button>
                      </div>
                    </div>
                    <div className="text-3xl font-bold pt-6">
                      Hola{" "}
                      <div>{capitalizeFirstLetter(props.name)}</div>
                    </div>
                    <div className="pt-4">
                      <div className="bg-purpleLight p-4 w-full rounded-xl">
                        <div className="flex">
                          <div className="w-24 h-auto">
                            <LevelProgressbar />
                          </div>
                          <div className="pl-2">
                            <Title />
                            <LevelData setOpenCharacter={setOpen} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="grid content-between h-full">
                    <div className="grid gap-4 pt-6">
                      {navigation.map((item, index) => (
                        <a
                          key={item.name + index}
                          href={item.href}
                          target={item?.id === "WA" ? "_blank" : "_self"}
                          className="flex cursor-pointer group"
                        >
                          {item.disclosure && (
                            <div className="relative w-full">{item.disclosure}</div>
                          )}
                          {item.name && (
                            < Fragment key={'fragment-item-' + index}>

                              {
                                item?.id === "RE" || item?.id === "WA" && item?.onClick ?
                                  <div className="flex w-full gap-2 py-1" onClick={item.onClick}>
                                    <div className="w-5 h-auto">{item.icon}</div>
                                    {
                                      pendingsRewards > 0 &&
                                      (<div className={`absolute w-3 h-3 bg-red rounded-full left-7 top-160 border border-2 border-purpleLight`}></div>)
                                    }
                                    <div>{item.name}</div>
                                  </div>
                                  :
                                  <>
                                    <div className="flex w-full gap-2 py-1">
                                      <div className="w-5 h-auto">{item.icon}</div>
                                      <div>{item.name}</div>
                                    </div>
                                  </>
                              }
                            </Fragment>
                          )}
                          {item.name && (
                            <div className="grid content-center">
                              <ChevronRightIcon className="w-5 h-auto" />
                            </div>
                          )}
                        </a>
                      ))}
                    </div>
                    <a
                      onClick={handleCloseSession}
                      href="#"
                      className="flex gap-2 w-auto">
                      <ArrowRightStartOnRectangleIcon className="w-5 h-auto" />
                      <div>Cerrar sesión</div>
                    </a>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}

export function MenuCloseSession() {
  const navigate = useNavigate();

  const handleCloseSession = () => {
    closeSession();
    navigate("/ingresar");
  }

  return (
    <Menu>
      <MenuButton href="#">
        <div>
          <img
            className="h-14 w-auto rounded-full cursor-pointer"
            src={localStorage.getItem('avatar') ?? avatarImgDefault}
            alt="Galilea"
          />
        </div>
      </MenuButton>
      <MenuItems
        transition
        anchor="bottom end"
        className="mt-2 origin-top-right font-walsheim tracking-tight rounded-xl text-sm bg-white px-4 py-2 text-tdark transition duration-100 ease-out data-[closed]:scale-95 data-[closed]:opacity-0"
      >
        <MenuItem>
          <a
            onClick={handleCloseSession}
            href="#"
            className="group flex w-full items-center gap-1 py-1"
          >
            <ArrowRightStartOnRectangleIcon className="w-4 h-auto" />
            <div>Cerrar sesión</div>
          </a>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
}
